import React, { useCallback, useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GenericFilterHeader } from './GenericFilterHeader';
import { GET_ADVERTISING_ZONES_FILTER } from '../../../../apollo/queries/advertisingZone';
import { AdvertisingZone } from '../../../../codegen/graphql';

interface AdvertisingZoneHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

type AdvertisingZonesFilterResult = {
    getAdvertisingZones: AdvertisingZone[];
};

export function AdvertisingZoneHeader({
    currentValue,
    onChange,
}: AdvertisingZoneHeaderProps) {
    const [fetchZones, { data: advertisingZonesData, loading }] =
        useLazyQuery<AdvertisingZonesFilterResult>(
            GET_ADVERTISING_ZONES_FILTER,
            { fetchPolicy: 'cache-first' },
        );

    const handleOpen = useCallback(() => {
        fetchZones();
    }, [fetchZones]);

    const filterOptions = useMemo(() => {
        if (!advertisingZonesData) return ['All', 'Unassigned'];
        const uniqueNames = new Set<string>();
        advertisingZonesData.getAdvertisingZones.forEach(zone => {
            if (zone.name) {
                uniqueNames.add(zone.name);
            }
        });
        return [
            'All',
            'Unassigned',
            ...Array.from(uniqueNames).sort((a, b) => a.localeCompare(b)),
        ];
    }, [advertisingZonesData]);

    return (
        <GenericFilterHeader
            label="Advertising Zone"
            filterOptions={filterOptions}
            currentValue={currentValue}
            onChange={onChange}
            onOpen={handleOpen}
            loading={loading}
        />
    );
}
